import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import * as moment from 'moment';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {hourValidator, minuteValidator} from '../validators/validatorFunctions';

@Component({
  selector: 'gt-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.scss']
})
export class TimeInputComponent implements OnInit, OnChanges {
  private readonly HOURFORMAT = 'HH';
  private readonly MINUTEFORMAT = 'mm';

  @Input() parentForm: UntypedFormGroup;
  @Input() name: string;
  @Input() time: moment.Moment;
  @Input() disabled = false;
  @Input() required = false;
  @Input() hasWrapAround = false;
  @Output() timeChange = new EventEmitter<moment.Moment>();
  hoursFormControl: UntypedFormControl;
  minutesFormControl: UntypedFormControl;

  constructor() {}

  ngOnInit() {
    const hour = this.getTime(this.HOURFORMAT, this.time);
    const minute = this.getTime(this.MINUTEFORMAT, this.time);

    this.hoursFormControl = new UntypedFormControl({ value: hour, disabled: this.disabled }, [hourValidator()]);
    this.minutesFormControl = new UntypedFormControl({ value: minute, disabled: this.disabled }, [minuteValidator()]);
    if (this.parentForm) {
      this.parentForm.addControl(`${this.name}_hours`, this.hoursFormControl);
      this.parentForm.addControl(`${this.name}_minutes`, this.minutesFormControl);
    }
  }

  ngOnChanges() {
    if (this.hoursFormControl === undefined || this.minutesFormControl === undefined) {
      return;
    }
    if (this.disabled) {
      this.hoursFormControl.disable();
      this.minutesFormControl.disable();
    } else {
      this.hoursFormControl.enable();
      this.minutesFormControl.enable();
    }
    this.handleOverflow();

  }

  handleOverflow() {
    if (this.hoursFormControl === undefined || this.minutesFormControl === undefined) {
      return;
    }

    const hourString = this.hoursFormControl.value;
    const minuteString = this.minutesFormControl.value;
    if (hourString && minuteString) {
      const time = moment().hour(hourString).minutes(minuteString);
      if (time.hours() < 10) {
        this.hoursFormControl.setValue('0' + time.hours().toString());
      } else {
        this.hoursFormControl.setValue(time.hours());
      }

      if (time.minutes() < 10) {
        this.minutesFormControl.setValue('0' + time.minutes().toString());
      } else {
        this.minutesFormControl.setValue(time.minutes());
      }
    }
  }

  emitTime() {
    if (this.hoursFormControl.valid && this.minutesFormControl.valid) {
      const hourString = this.hoursFormControl.value;
      const minuteString = this.minutesFormControl.value;
      if (hourString && minuteString) {
        const hour = parseInt(hourString, 10);
        const minute = parseInt(minuteString, 10);
        const time = moment()
          .set('hour', hour)
          .set('minute', minute)
          .set('seconds', 0);
        this.timeChange.emit(time);
      } else {
        this.timeChange.emit(null);
      }
    }
  }

  private getTime(format: string, time: moment.Moment): string {
    return time && time.isValid() ? time.format(format) : '0';
  }
}
